module.exports = __webpack_public_path__ + "img/Group-One.49ce6bda.svg";